import type { Job } from '@/api/endpoints/jobs'

type QueueFields = Pick<Job, 'status'> & Partial<Pick<Job, 'queue_position' | 'cancel_requested_at' | 'category'>>

/**
 * O rótulo do status de um job, com o estado da fila (docs/plan-job-queue.md,
 * F2): a posição de quem espera e o "Cancelando…" de quem já recebeu o pedido.
 * O `running` diz o que o job faz pela categoria (F4a): "Aplicando" num de
 * upload (as capas dos Shorts), "Gerando" no resto. Sem os campos novos
 * (backend anterior), cai nos rótulos de sempre.
 */
export function queueLabel(job: QueueFields): string {
  switch (job.status) {
    case 'pending':
      return typeof job.queue_position === 'number'
        ? `Na fila (posição ${String(job.queue_position)})`
        : 'Aguardando'
    case 'running':
      if (job.cancel_requested_at) return 'Cancelando…'
      return job.category === 'upload' ? 'Aplicando' : 'Gerando'
    case 'succeeded':
      return 'Concluído'
    case 'failed':
      return 'Falhou'
    case 'cancelled':
      return 'Cancelado'
    default:
      return job.status
  }
}

/** "N em execução, M na fila", para a seção de ativos da tela de Jobs. */
export function activeSummary(active: ReadonlyArray<Pick<Job, 'status'>>): string {
  const queued = active.filter((j) => j.status === 'pending').length
  const running = active.length - queued
  return `${String(running)} em execução, ${String(queued)} na fila`
}
